export default __webpack_public_path__ + "static/media/243.badef4bb.png";